import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import cn from 'classnames';
import theme from '../styles/theme';
import { getScrollBarWidth } from '../helpers/measure';

const FullViewportContainer = ({
  children, classes, className, id,
}) => (
  <div id={id} className={cn(classes.stretch, className)}>
    {children}
  </div>
);

FullViewportContainer.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.string,
  id: PropTypes.string,
};

FullViewportContainer.defaultProps = {
  children: undefined,
  className: undefined,
  id: undefined,
};

export default injectSheet({
  stretch: {
    '.columns &': {
      margin: [0, -theme.padding.horizontal],
      [theme.breakpoints.up(theme.breakpoints.width('xl') + theme.padding.horizontal * 2)]: {
        margin: [0, `calc(${theme.breakpoints.width('xl') / 2}px - 50vw + ${getScrollBarWidth() / 2}px)`],
      },
    },
  },
})(FullViewportContainer);
